import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const isApplePayPaymentMethodSelected = createSelector(creditCardsState, (creditCards) => creditCards.activeCardId === OLO.Enums.PAYMENT_VENDOR_SERVICE.APPLE_PAY);
